import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "profile-panel" }
const _hoisted_2 = { class: "profile-header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "notice" }
const _hoisted_7 = { class: "profile-meta" }
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "follower-count" }
const _hoisted_10 = { class: "platform-links" }
const _hoisted_11 = {
  class: "platform-link",
  href: "https://space.bilibili.com/335573347",
  target: "_blank",
  rel: "noopener noreferrer",
  title: "打开 B 站空间"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  class: "platform-link",
  href: "https://live.bilibili.com/23351494",
  target: "_blank",
  rel: "noopener noreferrer",
  title: "打开直播间"
}
const _hoisted_14 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "avatar",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleAvatarClick && _ctx.handleAvatarClick(...args)))
      }, [
        (_ctx.userInfo.pendant)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.userInfo.pendant,
              class: "pendant",
              alt: "pendant",
              referrerpolicy: "no-referrer"
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("img", {
          src: _ctx.userInfo.face,
          alt: "avatar",
          referrerpolicy: "no-referrer"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.userInfo.name), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.userInfo.notice), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: "follower",
        title: _ctx.followerExact
      }, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "follower-label" }, "粉丝", -1)),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formatFollower(_ctx.userInfo.follower)), 1)
      ], 8, _hoisted_8),
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"meta-note\" data-v-a6b49ab8><div class=\"note-row\" data-v-a6b49ab8><span class=\"note-label\" data-v-a6b49ab8>生日</span><span class=\"note-value\" data-v-a6b49ab8>4月23日</span></div><div class=\"note-row\" data-v-a6b49ab8><span class=\"note-label\" data-v-a6b49ab8>周年日</span><span class=\"note-value\" data-v-a6b49ab8>6月13日</span></div><div class=\"note-row\" data-v-a6b49ab8><span class=\"note-label\" data-v-a6b49ab8>粉丝群</span><span class=\"note-value\" data-v-a6b49ab8>673929083</span></div></div>", 1))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("a", _hoisted_11, [
        _createElementVNode("img", {
          src: _ctx.spaceLogo,
          alt: "B站空间"
        }, null, 8, _hoisted_12),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "platform-id" }, "335573347", -1))
      ]),
      _createElementVNode("a", _hoisted_13, [
        _createElementVNode("img", {
          src: _ctx.liveLogo,
          alt: "直播间"
        }, null, 8, _hoisted_14),
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "platform-id" }, "23351494", -1))
      ])
    ])
  ]))
}